import React from "react";
import { useMsal } from "@azure/msal-react";

export const AccessDenied = () => {
  const { instance } = useMsal();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <div className="text-center p-12 bg-slate-800 border border-slate-700 rounded-2xl max-w-md">
        <div className="text-5xl mb-4">🔒</div>
        <h2 className="font-serif text-slate-100 text-3xl mb-3">Access Restricted</h2>
        <p className="text-slate-400 mb-6 leading-relaxed">Your account has not been authorized to access LexCore. Please contact your system administrator to request access.</p>
        <button onClick={() => instance.logoutPopup()} className="px-6 py-3 bg-transparent border border-slate-700 text-yellow-600 hover:text-yellow-500 rounded-lg cursor-pointer font-medium transition-colors">Sign Out</button>
      </div>
    </div>
  );
};
